import React from "react";

import styles from './Header.module.css';

import IHeaderProps from "./dto/IHeaderProps";
import HeaderState from "./dto/HeaderState";

export default class Header extends React.Component<IHeaderProps, HeaderState> {
  constructor(props: IHeaderProps) {
    super(props);
    this.state = new HeaderState();
  }

  public render() {
    return (
      <header className={styles.header}>
        <img src="/img/logo-kern-dark-neu.png" alt="KERN Logo"></img>
      </header>
    );
  }
}